import { useMutation } from '@tanstack/react-query'
import { CreateAdvertiserParams, createAdvertiser } from 'supabase/advertisers'
import { queryClient } from 'utils'

export const useCreateAdvertiser = (
  onSuccess: (created: { id: string; name: string }) => any
) => {
  const mutation = useMutation({
    mutationFn: (advertiser: CreateAdvertiserParams) => {
      return createAdvertiser(advertiser)
    },
    onSuccess: (data: any, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['advertisers'],
      })

      if (data && data.id && data.name) {
        onSuccess({ id: data.id, name: data.name })
      } else {
        onSuccess(data)
      }
    },
  })

  return mutation
}